import { render, staticRenderFns } from "./ProjectTask.vue?vue&type=template&id=0d53642d&"
import script from "./ProjectTask.vue?vue&type=script&lang=js&"
export * from "./ProjectTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d53642d')) {
      api.createRecord('0d53642d', component.options)
    } else {
      api.reload('0d53642d', component.options)
    }
    module.hot.accept("./ProjectTask.vue?vue&type=template&id=0d53642d&", function () {
      api.rerender('0d53642d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/project/ProjectTask.vue"
export default component.exports